import { useEffect } from "react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { CandidateProfileEditor } from "@/components/settings/candidate-profile-editor"
import { useAuthGate } from "@/hooks/use-auth-gate"
import { needsCandidateOnboarding } from "@/lib/candidate"
import { Skeleton } from "@/components/ui/skeleton"

export const Route = createFileRoute("/candidate/settings/profile")({
  component: CandidateProfileSettings,
})

function CandidateProfileSettings() {
  const gate = useAuthGate()
  const navigate = useNavigate()

  useEffect(() => {
    if (gate.status === "ready" && needsCandidateOnboarding(gate.profile)) {
      void navigate({ to: "/onboarding/candidate", search: { returnTo: "/candidate/settings/profile" } })
    }
  }, [gate, navigate])

  if (gate.status !== "ready" || needsCandidateOnboarding(gate.profile)) {
    return <Skeleton className="h-64 w-full" />
  }

  return <CandidateProfileEditor />
}
